import React from 'react';
import P, { InferProps } from 'prop-types';
import Grid from '@mui/material/Grid';
import ImageField from './image-field';

function PromoFieldSubscription({
  setChange,
  setValidation,
  fields,
  isReadOnly,
  path,
}: InferProps<typeof PromoFieldSubscription.propTypes>) {
  const [
    contentUrlField,
    ,
    ,
    ,
    /* promoType */ /* targetUrlField */ /* promoOpenInAppField */ widthField,
    heightField,
  ] = fields;

  return (
    <Grid container spacing={4} alignItems="center">
      <Grid item>
        <ImageField
          field={contentUrlField}
          widthField={widthField}
          heightField={heightField}
          setChange={setChange}
          key={contentUrlField.id}
          isReadOnly={isReadOnly}
          path={path}
          compact
        />
      </Grid>
    </Grid>
  );
}

PromoFieldSubscription.propTypes = {
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  isReadOnly: P.bool,
  fields: P.any.isRequired,
  key: P.string,
  path: P.string.isRequired,
};

export default PromoFieldSubscription;
